import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import ilustracija from "../../img/Ilustracija.png";

const Blog1 = () => {
  const { t } = useTranslation();
  return (
    <>
      <Header></Header>
      <div className="container mx-auto mt-10">
        <h1 className="text-center mt-10 text-2xl font-bold">
          {t("blog1_title")}
        </h1>
        <h2 className="text-center font-bold mt-5">{t("blog1_subtitle1")}</h2>
        <div className="container mx-auto p-10 font-mont">
          <div>{t("blog1_section1")}</div>
          <br />
          <div>{t("blog1_section2")}</div>
          <br />
          <div>{t("blog1_section3")}</div>
          <img src={ilustracija} />
          <br />
          <div className="font-bold">{t("blog1_subtitle2")}</div>
          <br />
          <div>{t("blog1_section4")}</div>
          <br />
          <div>
            {t("blog1_section5")}
            <a href="#footnote-1">[1]</a>
          </div>
          <br />
          <div>{t("blog1_section6")}</div>
          <br />
          <div className="font-bold">{t("blog1_subtitle3")}</div>
          <br />
          <div>{t("blog1_section7")}</div>
          <br />
          <div>{t("blog1_section8")}</div>
          <br />
          <div id="footnote-1" className="text-xs">
            {t("blog1_footnote")}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog1;
